import React, { useEffect, useState } from 'react';
import '../../../styles/errorHandler.css'

function ErrorHandler(props) {
    const { errorHandler } = props;
    const [ show, setShow ] = useState(false);

    useEffect( () => { 
        setShow(false);        
        if(errorHandler.hasError){
            setShow(true);
        }

        // return () => {
        //   setShow({})  
        // };
    }, [errorHandler]);

    return (
        <div>
            { console.log('ErrorHandler.js errorHandler: ' + JSON.stringify(errorHandler)) }
            {show ? (
                <div className='statusUpdatesFailed'>
                    <h5>{JSON.stringify(errorHandler.message)}</h5>
                </div>
            ) : <div>
                </div>
            }

        </div>
    );
}

export default ErrorHandler;